import React from 'react';
import { Button, Flex, Modal, Typography, theme } from 'antd';
import { useSelector } from 'react-redux';

import type { RootState } from '../../reduxTypes';
import { keycloakLogin } from './runtimeAuth';

function SessionExpiredModal() {
  const { token } = theme.useToken();
  const sessionExpired = useSelector((state: RootState) => state.keycloak.sessionExpired);

  return (
    <Modal open={sessionExpired} closable={false} maskClosable={false} footer={null} zIndex={2000} width={420}>
      <Flex vertical gap={token.marginLG} align="center" style={{ padding: token.paddingLG }}>
        <Typography.Title level={4} style={{ margin: 0 }}>
          Session expired
        </Typography.Title>

        <div style={{ textAlign: 'center' }}>
          <Typography.Text>Your session expired due to inactivity.</Typography.Text>
          <br />
          <Typography.Text>Please sign in again to continue using Prerender.</Typography.Text>
        </div>
        <Button type="primary" size="large" onClick={keycloakLogin}>
          Sign in
        </Button>
      </Flex>
    </Modal>
  );
}

export default SessionExpiredModal;
